import { Adapter as s } from "../../../../../adapter.js";
import { ShopSessionAccessModel as o } from "./shopSessionAccess.model.js";
class a extends s {
  adapt(e) {
    return new o({
      pay: e.pay,
      paymentMethods: e.payment_methods
    });
  }
  serialize(e) {
  }
}
export {
  a as ShopSessionAccessAdapter
};
//# sourceMappingURL=shopSessionAccess.adapter.js.map
